import*as React from'react';import*as moment from'moment';var DatePickerPane=function DatePickerPane(props){var handleChange=function handleChange(event){var day=event.target.value?moment(event.target.value):moment();props.onChangeCreatedAtOnDay(day);};return<div className="d-flex flex-column position-relative shadow-sm mb-2">
      <div className="bg-primary text-white py-1 text-center rounded-top">
          日付
      </div>
      <div className="bg-light text-center p-2">
        <input className="form-control"type="date"onChange={handleChange}value={props.createdAtOnDay.format("YYYY-MM-DD")}/>
      </div>
    </div>;};export default DatePickerPane;